import React, {Component, Fragment} from "react";
import {DELETE_INTEGRATION, YES_DELETE, NO_DELETE} from "../../shared/messages";

export class DeleteIntegrationButton extends Component {
    constructor(props) {
        super(props);
        this.state = {showConfirmDelete:false};
    }

    //needs to be triggered on mousedown, because otherwise onBlur will override it
    handleDelete = (e) => {
        e.stopPropagation();
        if(e.button === 0){
            this.setState( {showConfirmDelete: false}, this.props.deleteAction );
        }
    }

    render() {
        return <Fragment>
            {this.state.showConfirmDelete ?
                <div className="confirm-delete" onBlur={()=>{this.setState({showConfirmDelete:false});}} >
                    <p>{DELETE_INTEGRATION}</p>
                    <button onMouseDown={this.handleDelete} className={"yes-delete"}>{YES_DELETE}</button>
                    <button onClick={()=>{this.setState({showConfirmDelete:false});}} autoFocus className={"no-delete"}>{NO_DELETE}</button>
                </div>
                :
                <button onClick={()=>{this.setState({showConfirmDelete:true});}} type="button" name="delete" className="delete-button"/>
            }
        </Fragment>;
    }

}